module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "style"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.title,
      "level": 2,
      "font": "oswald",
      "color": "yellow",
      "variant": "uppercase"
    }
  }), _vm._v(" "), _c('nav', [_c('router-link', {
    class: {
      selected: _vm.bandsSelected
    },
    attrs: {
      "to": {
        name: 'bandsByStyle'
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "group",
      "scale": "1.3"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('style.bands')))])], 1), _vm._v(" "), _c('router-link', {
    class: {
      selected: _vm.albumsSelected
    },
    attrs: {
      "to": {
        name: 'albumsByStyle'
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "music",
      "scale": "1.3"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('style.albums')))])], 1)], 1), _vm._v(" "), _c('router-view', {
    on: {
      "bands": _vm.onBands,
      "albums": _vm.onAlbums
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-760fa330"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/encyclopedia/Style.vue
// module id = 270
// module chunks = 0